import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import ItemSmall from './ItemSmall';
import ManageService from './ManageService';
import ReactModal from './ReactModal';
import { COLORS } from '../utils/colors';

const SmallListServices = (props) => {
  const { services, visible } = props;
  const [serviceModalIsOpen, setServiceModalIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const handleServiceClick = (service) => {
    setActiveItem(service);
    setServiceModalIsOpen(true);
  };

  if (!visible) return null;

  return (
    <div>
      {services.length > 0 && (
        <>
          <Grid item xs={12}>
            <p
              style={{
                fontSize: '0.8rem',
                fontWeight: 'bold',
                color: COLORS.INFO,
                textAlign: 'center',
                margin: '32px 0',
              }}
            >
              SERVICES
            </p>
          </Grid>
          <Grid container spacing={2} item xs={12}>
            {services.map((service) => {
              return (
                <Grid key={service.id} item xs={12} sm={12} md={6}>
                  <ItemSmall
                    item={service}
                    position={service.position}
                    action={() => handleServiceClick(service)}
                  />
                </Grid>
              );
            })}
          </Grid>
        </>
      )}

      {services.length === 0 && (
        <Grid item xs={12}>
          <p
            style={{
              fontSize: '0.8rem',
              fontWeight: 'bold',
              color: COLORS.INFO,
              textAlign: 'center',
              marginBottom: '32px',
            }}
          >
            Nothing found!
          </p>
        </Grid>
      )}

      {serviceModalIsOpen && (
        <ReactModal modalIsOpen={serviceModalIsOpen} setIsOpen={setServiceModalIsOpen}>
          <ManageService
            type="edit"
            serviceId={activeItem.id}
            onClose={() => setServiceModalIsOpen(false)}
          />
        </ReactModal>
      )}
    </div>
  );
};

export default SmallListServices;
